import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FiTodoListSectionItemComponent } from "./fi-todo-list-section-item.component";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { FiBindHtmlCompileModule } from "@fi-shared/fi-directives/bind-html-compile/bind-html-compile.module";
import { FiAttachmentsModule } from "@fi-shared/media-bank/fi-attachments/fi-attachments.module";
import { FiExpandableTextDirectiveModule } from "@fi-shared/fi-expandable-text-directive/fi-expandable-text-directive.module";
import { FormsModule } from "@angular/forms";
import { FiCheckboxClickAreaModule } from "@fi-shared/fi-directives/fi-chekbox-click-area/fi-checkbox-click-area.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatCheckboxModule,
        FiBindHtmlCompileModule,
        FiAttachmentsModule,
        FiExpandableTextDirectiveModule,
        FiCheckboxClickAreaModule,
    ],
    declarations: [
        FiTodoListSectionItemComponent,
    ],
    exports: [
        FiTodoListSectionItemComponent,
    ],
})
export class FiTodoListSectionItemModule {
}